<template>
  <div class="login-container">
    <header>
      <h1>ChatQPT</h1>
    </header>
    <main>
      <form @submit.prevent="handleSubmit">
        <div>
          <label for="email" style="font-size: 18px; font-weight: bold; font-style: italic;">To use ChatQPT, please
            input your email address and university/institution name</label>
          <input type="email" id="email" v-model="email" placeholder="Enter email" required />
        </div>
        <div>
          <!-- <label for="institution">Enter university/institute</label> -->
          <input type="text" id="institution" v-model="institution" placeholder="Enter university/institute" required />
        </div>
        <VueRecaptcha v-if="showRecaptcha" sitekey="6LddAmMhAAAAAOFvuGyIJ8SyyIHwfXT4tVddtiNd"
          :load-recaptcha-script="true" @verify="handleVerify" @fail="handleFail"></VueRecaptcha>
        <button type="submit">Submit</button>
      </form>
    </main>
  </div>
</template>

<script>
import { getCurrentInstance, ref, onMounted } from "vue";
import { useRouter } from 'vue-router';
import VueRecaptcha from 'vue3-recaptcha2';

export default {
  components: {
    VueRecaptcha,
  },
  setup() {
    const instance = getCurrentInstance();
    const axios = instance.appContext.config.globalProperties.$axios;
    const router = useRouter();
    const email = ref('');
    const institution = ref('');
    const showRecaptcha = ref(false);
    const recaptcha = ref(false)

    onMounted(() => {
      loadRecaptchaScript();
    });

    const loadRecaptchaScript = () => {
      const script = document.createElement('script');
      script.src = 'https://recaptcha.net/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);

      window.vueRecaptchaApiLoaded = () => {
        showRecaptcha.value = true;
      };
    };

    const handleSubmit = () => {
      if (recaptcha.value || !showRecaptcha.value) {
        // alert(`Email: ${email.value}, Institution: ${institution.value}`);
        axios.post("chatdb/login", { email: email.value, institute: institution.value })
          .then(() => {
            localStorage.setItem('email', email.value);
            router.push('/');
          })
          .catch(error => {
            alert("Can't connect to server, please try later")
          });
      } else {
        alert("Please verify you are not a robot before proceeding!")
      }

    };

    const handleVerify = (response) => {
      recaptcha.value = true;
    };

    const handleFail = () => {
      console.log('reCAPTCHA error');
      showRecaptcha.value = false;
    };

    return {
      email,
      institution,
      showRecaptcha,
      recaptcha,
      handleSubmit,
      handleVerify,
      handleFail,
    };
  }
};
</script>

<style scoped>
.login-container {

  text-align: center;

  font-family: Avenir, Helvetica, Arial, sans-serif;

  color: #2c3e50;

  height: 100vh;

  display: flex;

  flex-direction: column;

}

header {

  background-color: #4285f4;

  color: white;

  padding: 0px;

  margin-bottom: px;

}

main {

  flex-grow: 1;

  display: flex;

  justify-content: center;

  align-items: center;

}

form {

  display: flex;

  flex-direction: column;

  align-items: center;

}

div {

  margin-bottom: 15px;

}

label {

  display: block;

  margin-bottom: 5px;

}

input {

  padding: 12px;

  width: 700px;

  border: 1px solid #ccc;

  border-radius: 4px;

  font-size: 18px;

}

button {

  padding: 14px 30px;

  background-color: #4285f4;

  color: white;

  border: none;

  border-radius: 4px;

  cursor: pointer;

  font-size: 18px;

}

button:hover {

  background-color: #357ae8;

}
</style>